import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    firebaseUser: null
  },
  actions: {
    unsetFirebaseUser ({ commit }) {
      commit('firebaseUser', null)
    },
    fetchUserProfile ({ commit, state }) {
    },
    updateProfile ({ commit, state }, data) {
    }
  },
  mutations: {
    firebaseUser (state, val) {
      state.firebaseUser = val
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js